import AlertDisabledAccount from './AlertDisabledAccount';

export default AlertDisabledAccount;
